<div
  bsModal
  #approveClientUploadRow="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left"></h4>
        <button
          type="button"
          class="close pull-right"
          name="approveClientUploadRowCloseButton"
          aria-label="Close"
          (click)="hideChildModal()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>

      <div class="modal-body">
        <base-table-layout
          [records]="grid"
          [footer]="footer"
          [gridActions]="gridActions"
          [hasRowCheckbox]="hasRowCheckbox"
          [settings]="columnSetting"
          [searched]="searched"
          [loading]="loading"
          [downloading]="downloading"
          [count]="count"
          [visuals]="visuals"
          [genericVisuals]="genericVisuals"
          (outputMethodHandler)="outputMethodHandler($event)"
          [sortNum]="sortNum"
          [sortDir]="sortDir"
          (changeSortHandler)="changeSort($event)"
          [pageSize]="pageSize"
          [pageNum]="pageNum"
          [pageMax]="pageMax"
          (changePageHandler)="changePage($event)"
          (changePageSizeHandler)="changePageSize($event)"
        >
        </base-table-layout>
      </div>
    </div>
  </div>
</div>
